"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PropertyCondition_1 = require("./PropertyCondition");
class PrimitivePropertyCondition extends PropertyCondition_1.PropertyCondition {
    constructor(property, type) {
        super(property);
        this.type = type;
    }
    isFulfilled(value) {
        const propertyResult = super.checkProperty(value);
        if (propertyResult.isFinal) {
            return propertyResult.result;
        }
        const type = typeof value[this.property];
        if (type !== this.type) {
            return this.createUnfulfilledResult(value, `is a ${type}, but expected ${this.type}`);
        }
        return { fulfilled: true };
    }
}
exports.PrimitivePropertyCondition = PrimitivePropertyCondition;
//# sourceMappingURL=PrimitivePropertyCondition.js.map